import { Flex } from '@chakra-ui/react';
import SkeletonComponent from 'UiKit/skeleton';

const PaginationSkeleton = () => (
  <Flex gap="8px" alignItems="center" data-testid="pagination-skeleton">
    <SkeletonComponent width="45px" height="18px" />
    <SkeletonComponent width="24px" height="24px" />
    <SkeletonComponent width="24px" height="24px" />
    <SkeletonComponent width="24px" height="24px" />
    <SkeletonComponent width="45px" height="18px" />
  </Flex>
);

export default PaginationSkeleton;
